import React from 'react'
import { Spinner } from 'react-bootstrap';

const TotalBusiness = ({totalBusinesses, dataLoading}) => {
  
  return (
    <>
      {dataLoading ? <div className='text-center mt-4'>
                          <Spinner animation="border" role="status" />
                      </div> : 
      <div className='flex flex-col'>
        <div className='flex justify-between items-center'>
          <span className='text-sm font-bold text-muted'>TOTAL BUSINESSES</span>
          <span>
            <img src='/images/businesses.png' alt='businesses' width={50} height={50} />
          </span>
        </div>
        <h3 className=''>{totalBusinesses}</h3>
        <span></span>
    </div>}
  </>
  )
}

export default TotalBusiness